"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StopCardFieldWarningsDescriptions = exports.StopCardFieldWarningsLabels = exports.StopCardFieldDescriptions = exports.StopCardFieldLabels = exports.StopCardFieldWarning = exports.StopCardField = exports.StopCardFieldWarnings = exports.StopCardFields = void 0;
const typebox_1 = require("@sinclair/typebox");
/**
 * Every field a dispatch stop card can show, across task types.
 *
 * Where two task types show the same fact with the same label — customer name, PO number, notes — they
 * share one key, so a hauler configures it once and both card types honour it. Those shared keys kept
 * their historical `order.`-prefixed names rather than forcing a rename of strings already stored in
 * every hauler's preference row; the prefix is history, not scope.
 *
 * Keys that are genuinely one type's own stay separate: `order.material` and `order.boxNumber` mean
 * nothing to a portable toilet, and `subscription.frequency` means nothing to a roll-off. Each task type
 * declares which keys it supports, and a card renders only those.
 *
 * Adding a key needs no preference migration — the Customize modal offers the union of what the hauler's
 * entitled types support, so a key absent from their stored row shows up as available and disabled.
 */
exports.StopCardFields = [
    // Roll-off only
    'order.material',
    'order.dumpsterSize',
    'order.boxNumber',
    'order.orderNumber',
    'order.rentalEndDate',
    // Portable toilet only
    'subscription.equipment',
    'subscription.number',
    'subscription.serviceStartDate',
    'subscription.serviceEndDate',
    'subscription.frequency',
    'subscription.requestedDays',
    // Shared by every task type. `order.`-prefixed for historical reasons only — see the note above.
    'order.customerDisplayName',
    'order.poNumber',
    'driverNotes',
    // Always Defaulted on fields
    'taskType',
    'address',
    'disposalFacility',
];
exports.StopCardFieldWarnings = ['displayOutStandingBalances', 'showSeviceAgreementNotSigned'];
exports.StopCardField = typebox_1.Type.Union(exports.StopCardFields.map((m) => typebox_1.Type.Literal(m)));
exports.StopCardFieldWarning = typebox_1.Type.Union(exports.StopCardFieldWarnings.map((m) => typebox_1.Type.Literal(m)));
exports.StopCardFieldLabels = {
    'order.material': 'Material',
    'order.dumpsterSize': 'Dumpster Size',
    'order.boxNumber': 'Box Number',
    'order.orderNumber': 'Order Number',
    'order.customerDisplayName': 'Customer Display Name',
    'order.rentalEndDate': 'Rental End Date',
    'order.poNumber': 'PO Number',
    'subscription.equipment': 'Equipment',
    'subscription.number': 'Rental Number',
    'subscription.serviceStartDate': 'Service Start Date',
    'subscription.serviceEndDate': 'Service End Date',
    'subscription.frequency': 'Frequency',
    'subscription.requestedDays': 'Requested Days',
    driverNotes: 'Driver Notes',
    // Always Defaulted on fields
    taskType: 'Task Type',
    address: 'Address',
    disposalFacility: 'Disposal Facility',
};
exports.StopCardFieldDescriptions = {
    'order.customerDisplayName': 'Displays the company name, or the primary contact if no company name is set',
    'order.material': '',
    'order.dumpsterSize': '',
    'order.boxNumber': '',
    'order.orderNumber': '',
    'order.rentalEndDate': '',
    'order.poNumber': '',
    'subscription.equipment': 'Quantity and type of the units on the rental, e.g. "3 Standard"',
    'subscription.number': '',
    'subscription.serviceStartDate': 'Start of the serviced period, from the order if it has one, otherwise the rental',
    'subscription.serviceEndDate': 'End of the serviced period, from the order if it has one, otherwise the rental',
    'subscription.frequency': 'How often the unit is serviced, e.g. "2x weekly"',
    'subscription.requestedDays': 'Days of the week the customer asked to be serviced on',
    driverNotes: 'Displays notes marked "visible to drivers" (set in Tasks & Notes)',
    // Always Defaulted on fields
    taskType: 'Delivery, Pickup, Swap',
    address: '',
    disposalFacility: 'Only displayed on Pickup tasks',
};
exports.StopCardFieldWarningsLabels = {
    displayOutStandingBalances: 'Invoice past due',
    showSeviceAgreementNotSigned: 'Show service agreement not signed',
};
exports.StopCardFieldWarningsDescriptions = {
    displayOutStandingBalances: 'Flag for when an order is unpaid and overdue',
    showSeviceAgreementNotSigned: "Flag for when a customer's agreement is pending signature",
};
//# sourceMappingURL=stop-card-fields.js.map